(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("aws_amplify_auth"), require("aws_amplify_cache"), require("aws_amplify_core"), require("graphql"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_api", ["aws_amplify_auth", "aws_amplify_cache", "aws_amplify_core", "graphql"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_api"] = factory(require("aws_amplify_auth"), require("aws_amplify_cache"), require("aws_amplify_core"), require("graphql"));
	else
		root["aws_amplify_api"] = factory(root["aws_amplify_auth"], root["aws_amplify_cache"], root["aws_amplify_core"], root["graphql"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__aws_amplify_auth__, __WEBPACK_EXTERNAL_MODULE__aws_amplify_cache__, __WEBPACK_EXTERNAL_MODULE__aws_amplify_core__, __WEBPACK_EXTERNAL_MODULE_graphql__) {
return 